import { queryTransaction } from '@/api/transactions'

const actions = {
    FETCH_TRANSACTION_DETAILS: ({ commit }, payload) => {
        commit('COMMIT_LOADING_TRANSACTION_STATUS', true)

        queryTransaction(payload)
            .then((data) => {
                commit('COMMIT_LOADING_TRANSACTION_STATUS', false)
                commit('COMMIT_TRANSACTION_DETAILS', data.data.transaction)
            })
            .catch((err) => {
                commit('COMMIT_LOADING_TRANSACTION_STATUS', false)
                console.dir(err)
            })
    },
}

export default actions
